import { Component, inject, signal } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { MpsUserService } from '../../services/mps-user.service';
import { MpsFooterComponent } from '../mps-footer/mps-footer.component';
import { MpsHeaderComponent } from '../mps-header/mps-header.component';
import { MpsLoaderComponent } from '../mps-loader/mps-loader.component';
import { MpsNavigationComponent } from '../mps-navigation/mps-navigation.component';

@Component({
  selector: 'mps-app-root',
  templateUrl: './mps-app.component.html',
  styleUrl: './mps-app.component.scss',
  imports: [
    MpsLoaderComponent,
    MpsHeaderComponent,
    MpsFooterComponent,
    MpsNavigationComponent,
    TranslateModule,
    MatSidenavModule,
    RouterOutlet,
  ],
})
export class MpsAppComponent {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private translateService = inject(TranslateService);
  private userService = inject(MpsUserService);
  private user = signal(this.userService.getUserSubject().getValue());

  public constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('fr-FR');
    this.registerSvgIcon();
    this.initTranslationService();
  }

  private initTranslationService() {
    this.translateService.setDefaultLang(environment.defaultLocale);
    this.translateService.addLangs(environment.allowedLanguage);

    // Set a default language if there's no language set
    if (!this.translateService.currentLang) {
      this.translateService.use((localStorage.getItem('lang') as string) || environment.defaultLocale);
    }
  }

  private registerSvgIcon() {
    const icons = [...environment.mpsIcons, ...environment.appIcons];

    icons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        `total-${icon}`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../../../assets/icons/${icon}.svg`)
      );
    });
  }
}
